import { createReducer, on } from '@ngrx/store';
import { MasterActions } from './configuration.actions';
import {
  LISTITEM,
  MasterItem,
  VehicleChecklistItem,
} from '@core/interface/configuration';
import lodash from 'lodash';
import { Pagination } from '@core/interface/core';

export const masterFeatureKey = 'master';

export interface ListItemState {
  data: MasterItem[];
  isLoading: boolean;
  isDeleted: boolean;
  pagination: Pagination | null;
}

export type MasterState = Record<LISTITEM, ListItemState> & {
  vehicleChecklist: {
    data: VehicleChecklistItem[];
    isLoading: boolean;
    pagination: Pagination | null;
    isUpdating: boolean;
  };
};
const ListItems = Object.fromEntries(
  Object.values(LISTITEM).map((key) => [
    key,
    {
      data: [],
      isLoading: true,
      isDeleted: false,
      pagination: null,
    },
  ])
) as unknown as Record<LISTITEM, ListItemState>;
export const initialState: MasterState = {
  ...ListItems,
  vehicleChecklist: {
    data: [],
    isLoading: true,
    pagination: null,
    isUpdating: false,
  },
};

export const MasterReducer = createReducer(
  initialState,
  on(MasterActions.loadMasterList, (state, action) => {
    return {
      ...state,
      [action.key]: { ...state[action.key], data: [], isLoading: true },
    };
  }),
  on(MasterActions.loadMasterListSuccess, (state, action) => {
    return {
      ...state,
      [action.key]: {
        ...state[action.key],
        data: action.response.data,
        isLoading: false,
        pagination: action.response.pagination,
      },
    };
  }),
  on(MasterActions.loadMasterListFailure, (state, action) => {
    return {
      ...state,
      [action.key]: { ...state[action.key], data: [], isLoading: false },
    };
  }),
  on(MasterActions.updateMasterSuccess, (state, action) => {
    const index = state[action.key].data.findIndex(
      (item) => item.id == action.response.data.id
    );
    let data = [...state[action.key].data];
    if (index == -1) data = [...state[action.key].data, action.response.data];
    else data[index] = action.response.data;

    return {
      ...state,
      [action.key]: {
        ...state[action.key],
        data: data,
      },
    };
  }),
  on(MasterActions.deleteMaster, (state, action) => ({
    ...state,
    [action.key]: {
      ...state[action.key],
      isDeleted: false,
    },
  })),
  on(MasterActions.deleteMasterSuccess, (state, action) => ({
    ...state,
    [action.key]: {
      ...state[action.key],
      data: state[action.key].data.filter(
        (item: MasterItem) => item.id !== action.response.id
      ),
      isDeleted: true,
    },
  })),
  on(MasterActions.deleteMasterFailure, (state, action) => ({
    ...state,
    [action.key]: {
      ...state[action.key],
      isDeleted: false,
    },
  })),
  on(MasterActions.resetMasterList, (state, action) => ({
    ...state,
    [action.key]: {
      ...state[action.key],
      data: [],
      isDeleted: false,
    },
  })),
  on(MasterActions.resetMasterStatus, (state, action) => ({
    ...state,
    [action.key]: {
      ...state[action.key],
      isDeleted: false,
    },
  })),

  on(MasterActions.loadDynamicVehicleChecklist, (state, data) => {
    return {
      ...state,
      vehicleChecklist: {
        ...state.vehicleChecklist,
        isLoading: true,
        data: [],
        pagination: null,
      },
    };
  }),
  on(
    MasterActions.loadDynamicVehicleChecklistSuccess,
    (state, { data, pagination }) => {
      return {
        ...state,
        vehicleChecklist: {
          ...state.vehicleChecklist,
          isLoading: false,
          data: data,
          pagination,
        },
      };
    }
  ),
  on(MasterActions.loadDynamicVehicleChecklistFailure, (state) => {
    return {
      ...state,
      vehicleChecklist: {
        ...state.vehicleChecklist,
        isLoading: true,
        data: [],
        pagination: null,
      },
    };
  }),
  on(MasterActions.addEditDynamicVehicleChecklist, (state) => ({
    ...state,
    vehicleChecklist: { ...state.vehicleChecklist, isLoading: true },
  })),
  on(MasterActions.addEditDynamicVehicleChecklistSuccess, (state, { data }) => {
    const index = state.vehicleChecklist.data.findIndex(
      (item) => item.id == data.id
    );
    let vehicleChecklist = [...state.vehicleChecklist.data];
    if (index == -1) vehicleChecklist = [...state.vehicleChecklist.data, data];
    else vehicleChecklist[index] = data;

    return {
      ...state,
      vehicleChecklist: {
        ...state.vehicleChecklist,
        data: vehicleChecklist,
        isLoading: false,
      },
    };
  }),
  on(MasterActions.addEditDynamicVehicleChecklistFailure, (state) => ({
    ...state,
    vehicleChecklist: { ...state.vehicleChecklist, isLoading: false },
  }))
);
